import { HttpRequest, IHttpClient } from "@features/shared/request/model";
import { IRoadmapsConfig, IRoadmapsResponse } from "../entities/roadmaps";
import { withLocale } from "@features/shared/locale";

const SERVER_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

export class TRoadmapsApi {
    constructor(private httpClient: IHttpClient) {}

    async getRoadmaps() {
        let includeDrafts = false;
        if (typeof window !== "undefined") {
            try {
                includeDrafts = window.localStorage.getItem("roadmaps_draft") === "true";
            } catch (_) {}
        }

        return await this.httpClient.do<IRoadmapsResponse>(
            withLocale(`${SERVER_URL}/roadmaps${includeDrafts ? "?drafts=1" : ""}`)
        );
    }

    async getRoadmapsConfig() {
        return await this.httpClient.do<IRoadmapsConfig>(`${SERVER_URL}/roadmaps/config`);
    }
}

export const RoadmapsApi = new TRoadmapsApi(HttpRequest);
